import { JustifyContent, SizeType } from '@payflip/types/product-builder';
import styled, { css } from 'styled-components';
import { button } from '../button/styled';

export const resetAnchor = css`
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  text-decoration: none;
`;

export interface StyledLinkButtonProps {
  variant: 'primary' | 'secondary' | 'tertiary' | 'success' | 'alert';
  size: SizeType;
  disabled: boolean;
  $fullWidth: boolean;
  $contentLayout: JustifyContent;
}

export const StyledLinkButton = styled.a<StyledLinkButtonProps>`
  display: flex;
  justify-content: ${({ $contentLayout }): string => $contentLayout};
  ${({ $fullWidth }): { [key: string]: string } => {
    if ($fullWidth) {
      return {
        width: 'auto'
      };
    } else {
      return {
        width: 'fit-content'
      };
    }
  }};
  ${resetAnchor}
  ${button}
`;
